export const isServerside = (): boolean => typeof window === 'undefined';
